import { render, staticRenderFns } from "./CentralKitchenCard.vue?vue&type=template&id=0851952e&"
import script from "./CentralKitchenCard.vue?vue&type=script&lang=js&"
export * from "./CentralKitchenCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports